// Política de contraseña — debe coincidir EXACTAMENTE con
// server/auth/passwordPolicy.js (ver informe "LYNX — Fase 1.1: Usuarios y
// Seguridad"). Este módulo es solo para feedback inmediato en el
// formulario — el servidor siempre vuelve a validar, nunca confía en esto.
export const PASSWORD_MIN_LENGTH = 8;

export type PasswordValidationResult = {
  valid: boolean;
  message: string | null;
};

export function validatePassword(password: string): PasswordValidationResult {
  if (!password) {
    return { valid: false, message: "La contraseña es obligatoria." };
  }
  if (password.length < PASSWORD_MIN_LENGTH) {
    return { valid: false, message: `Debe tener al menos ${PASSWORD_MIN_LENGTH} caracteres.` };
  }
  if (!/[A-Z]/.test(password)) {
    return { valid: false, message: "Debe contener al menos una mayúscula." };
  }
  if (!/[a-z]/.test(password)) {
    return { valid: false, message: "Debe contener al menos una minúscula." };
  }
  if (!/[0-9]/.test(password)) {
    return { valid: false, message: "Debe contener al menos un número." };
  }
  return { valid: true, message: null };
}
